import { Clonable } from '../../..';

export class TeamGroup extends Clonable {
  constructor(
    public readonly id: string,
    public readonly createdAt: Date,
    public readonly email: string,
    public readonly name: string,
    public readonly teamId: string,
    public readonly users: string[],
  ) {
    super();
  }
}
